import { useState } from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import axios from 'axios'
import { useSignIn, useIsAuthenticated } from 'react-auth-kit'

import ClosingAlert from '../usables/Alert'

import Input from '../usables/small/Input'
import Button from '../usables/small/ButtonReal'

export default function Login() {
  const signIn = useSignIn()
  const [formData, setFormData] = useState({email: '', password: ''})
  const [showError, setShowError] = useState(false)
  const navigate = useNavigate()
  const isAuthenticated = useIsAuthenticated()
  
  const onSubmit = (e) => {
    e.preventDefault()
    axios.post(process.env.REACT_APP_API + '/auth/login', formData)
      .then((res)=>{
        if(res.status === 200){
          const config = {
            headers: {
              Authorization: 'Bearer ' + res.data.access_token
            }
          }
          axios.get(process.env.REACT_APP_API + '/user/me', config)
            .then(resp => {
              if(resp.status === 200){
                if(signIn({token: res.data.access_token,
                  expiresIn:(res.data.expires_in / 60 - 1),
                  tokenType: 'Bearer',
                  authState: resp.data})) {
                  navigate('/')
                }
              }
            })
          }
        })
        .catch((err) => {
          setShowError(true)
        })
      }
      
    
  if(!isAuthenticated())
    return (
      <>
      <div className='w-full h-95 flex items-center justify-center m-auto'>
        <div className='max-w-md w-full m-auto mt-48 p-5 bg-white border rounded'>
          <ClosingAlert type='error' message='Neteisingas prisijungimo vardas arba slaptažodis' show={showError} updateState={(value) => {setShowError(value)}} />
          <h2 className='font-medium text-xl'>Prisijungti</h2>
          <form className='pt-5' onSubmit={onSubmit}>
          <Input
                label='El. paštas'
                name='email'
                type='email'
                value={formData.email}
                onChange={(e)=>setFormData({...formData, email: e.target.value})}
            />
            <Input
                label='Slaptažodis'
                name='password'
                type='password'
                value={formData.password}
                onChange={(e)=>setFormData({...formData, password: e.target.value})}
            />
            <Button text='Prisijungti' />
            
          {/* <input type={'email'} onChange={(e)=>setFormData({...formData, email: e.target.value})}/> */}
          {/* <input type={'password'} onChange={(e)=>setFormData({...formData, password: e.target.value})}/> */}
          {/* <div className='flex justify-center'> */}
          </form>
        </div>
      </div>
      </>
    )
  else
    return(<Navigate replace to='/protected' />)
}